import { useMemo } from 'react';

import { Observable, forkJoin, map, of } from 'rxjs';

import { getODataArray } from 'common/ODataAjaxUtil';
import { getControllerName } from 'common/widgets';

import { FullMember, PotentialHousehold, FullPotentialHouseholdMember } from '../interfaces/Member';
import { useObservable } from './useObservable';

const getPotentialHousehold = (memberIds, module): Observable<FullMember[]> =>
    getODataArray(`/api/${getControllerName(module)}/getpotentialhousehold?memberIds=${memberIds}`);

export const usePotentialHousehold = (
    potentialHouseholdItems: PotentialHousehold[],
    module: string,
): FullPotentialHouseholdMember[] | null => {
    const getPotentialHousehold$ = useMemo(() => {
        if (!potentialHouseholdItems?.length) return of([]);

        const memberIds = potentialHouseholdItems.map((s) => s.member).join();

        // getPotentialHousehold returns an array of FullMember objects
        const additionalProps$ = memberIds ? getPotentialHousehold(memberIds, module) : of([]);

        return forkJoin([of(potentialHouseholdItems), additionalProps$]).pipe(
            map(([potentialHousehold, additionalProps]) =>
                potentialHousehold.map((ph) => {
                    const member =
                        additionalProps?.find((fullMember) => fullMember.memberId === ph.member) || ({} as FullMember);
                    return { ...member, reason: ph.reason };
                }),
            ),
        );
    }, [potentialHouseholdItems, module]);

    return useObservable<FullPotentialHouseholdMember[] | null>(getPotentialHousehold$, null);
};
